import { useQuery } from "@tanstack/react-query";
import { orgBillingApi, type OrgPaymentMethod } from "@/api/org-billing-api";
import { useActiveOrg } from "@/hooks/use-active-org";

export function useOrgPaymentMethod() {
  const { orgId } = useActiveOrg();

  const query = useQuery<OrgPaymentMethod | null>({
    queryKey: ["orgPaymentMethod", orgId],
    queryFn: () => {
      if (!orgId) return null;
      return orgBillingApi.getPaymentMethod(orgId);
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    card: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
  };
}
